import { ReactNode } from "react";
import { Box } from "@mui/material";
import KpiCard from "components/cards/KpiCard";

export type KpiAccentColor = "error" | "warning" | "success" | "primary";

export interface IScheduleKpiCardDescriptor {
    key: string;
    title: string;
    icon: ReactNode;
    accentColor: KpiAccentColor;
    value: string;
    valueSuffix: string;
    description: string;
    tooltip?: string;
}

interface IScheduleKpiCardsProps {
    cards: IScheduleKpiCardDescriptor[];
}

const ScheduleKpiCards = ({ cards }: IScheduleKpiCardsProps): JSX.Element => (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        {cards.map(({ key, title, icon, accentColor, value, valueSuffix, description, tooltip }) => (
            <Box
                key={key}
                sx={{
                    display: "flex",
                    flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 8px)", md: "1 1 calc(25% - 12px)" },
                }}
            >
                <KpiCard
                    title={title}
                    value={value}
                    valueSuffix={valueSuffix}
                    icon={icon}
                    accentColor={accentColor}
                    description={description}
                    tooltip={tooltip}
                />
            </Box>
        ))}
    </Box>
);

export default ScheduleKpiCards;
